import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useBudgetId } from '../../budget/budget-store';
import { useApi } from '../../api/api-context';
export const useCreateAccountApi = (options) => {
    const api = useApi();
    const queryClient = useQueryClient();
    const budgetId = useBudgetId();
    const [isPending, setIsPending] = useState(false);
    const accountsKey = ['accounts', budgetId];
    const transactionsKey = ['transactions', budgetId];
    // api call
    const createAccountApi = async (data) => {
        await api.post('/account', data);
    };
    const mutation = useMutation({
        mutationFn: createAccountApi,
        onMutate: async (request) => {
            setIsPending(true);
            // Cancel any outgoing queries to avoid stale data
            await queryClient.cancelQueries({ queryKey: accountsKey });
            await queryClient.cancelQueries({ queryKey: transactionsKey });
            // Snapshot the previous cache state for rollback if needed
            const previousAccounts = queryClient.getQueryData(accountsKey);
            const previousTransactions = queryClient.getQueryData(transactionsKey);
            // Optimistically update accounts
            queryClient.setQueryData(accountsKey, (oldAccounts = []) => {
                const newAccount = { ...request };
                return [...oldAccounts, newAccount];
            });
            // Optimistically update transactions if there are any initial balance transactions
            if (request.transactions && request.transactions.length > 0) {
                queryClient.setQueryData(transactionsKey, (oldTransactions = []) => {
                    const newTransactions = [...oldTransactions, ...request.transactions];
                    return newTransactions.sort((a, b) => b.dateEpoch - a.dateEpoch || b.id.localeCompare(a.id));
                });
            }
            // Immediately call onSuccess after the optimistic update
            if (options?.onSuccess) {
                options.onSuccess();
            }
            return { accounts: previousAccounts, transactions: previousTransactions };
        },
        onError: (_error, _variables, context) => {
            // Rollback to the previous state if the mutation fails
            if (context?.accounts !== undefined) {
                queryClient.setQueryData(accountsKey, context.accounts);
            }
            if (context?.transactions !== undefined) {
                queryClient.setQueryData(transactionsKey, context.transactions);
            }
        },
        onSettled: () => {
            setIsPending(false);
        },
    });
    return { mutate: mutation.mutate, isPending };
};
